import React from 'react';
var EventContext = React.createContext({});
export var EventContextProvider = EventContext.Provider;
export var EventContextConsumer = EventContext.Consumer;
export default EventContext;
//# sourceMappingURL=event-context.js.map